import { Page} from "../components/styled";
import SwipeableTabs from "../components/shared/swipeableTabs";
import Upgrader from "./inlinePages/upgrader";
import Collection from "./inlinePages/collection";
import Syntesis from "./inlinePages/syntesis";
import { useDeck } from "../context/DeckContext";
import { useState,useEffect } from "react";
import { getLevels } from "../service/main/api";
import { rarityRank } from "../constants";


const Cards = () => {
    const {deck,userCards} = useDeck();
    const [levels,setLevels] = useState([]);
    const [sortedCards,setSortedCards] = useState([]);
   
    const calculateUpgradeDetails =  (targetCard) => {
         const realTarget = userCards.find(c=>c._id === targetCard._id);
         const targetLevel = levels.find(l=>l.value === realTarget.level.value + 1);
         const baseCost = targetLevel.baseCost;
         const upgradeCostMultiplier = realTarget.rarity.upgradeCostMultiplier;
         const cost = baseCost * upgradeCostMultiplier;
         const successRate = targetLevel.upgradeSuccessRate * 100;
         let roi = 0;
         switch (targetLevel.value) {
            case 2:
                roi = 30;
                break;
            case 3:
                roi = 60;
                break;
            case 4:
                roi = 90;
                break;
            case 5:
                roi = 120;
                break;
            default:
                break;
         }
         return {cost,successRate,roi};

    }

    useEffect(() => {
        getLevels().then((res) => {
            setLevels(res.data);
        });
    },[]);

    const sortCards = (type) => {
        const sorted = userCards.sort((a,b) => {
            if(type === "asc"){
                return rarityRank[a.rarity.name] - rarityRank[b.rarity.name];
            }
            return rarityRank[b.rarity.name] - rarityRank[a.rarity.name];
        });
        setSortedCards(sorted);
    };
    useEffect(() => {
        sortCards("desc");
    },[userCards]);
    return (
        <Page>
           <SwipeableTabs tabs={["Upgrade", "Collection","Syntesis"]}>
                    <Upgrader 
                        calculateUpgradeDetails={calculateUpgradeDetails} 
                        cards={sortedCards}/> 
                <Collection sort={sortCards} deck={deck} cards={sortedCards}/>
               <Syntesis cards={sortedCards}/> 
           </SwipeableTabs>
        </Page>
    );
}

export default Cards;